var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOlpenFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66666 7.66671V3.80825C2.66666 3.36698 2.66666 3.14635 2.70364 2.96257C2.86646 2.15353 3.54149 1.52069 4.40446 1.36805C4.6005 1.33337 4.83584 1.33337 5.30652 1.33337C5.51275 1.33337 5.61586 1.33337 5.71496 1.34206C6.1422 1.37952 6.54747 1.53689 6.87783 1.79363C6.95445 1.85318 7.02736 1.92154 7.17319 2.05825L7.46666 2.33337C7.90174 2.74126 8.11928 2.94521 8.37979 3.08109C8.52289 3.15573 8.67469 3.21468 8.83218 3.25676C9.11887 3.33337 9.42652 3.33337 10.0418 3.33337H10.2411C11.645 3.33337 12.347 3.33337 12.8033 3.71811C12.8453 3.7535 12.8852 3.79094 12.9229 3.83029C13.3333 4.25805 13.3333 4.91614 13.3333 6.23233V7.66671",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66666 11.3334H9.33332",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31783 11.656C1.99972 9.84523 1.84067 8.93986 2.22605 8.28871C2.3244 8.12254 2.44568 7.97214 2.58605 7.84227C3.13613 7.33337 4.02527 7.33337 5.80354 7.33337H10.1965C11.9747 7.33337 12.8639 7.33337 13.4139 7.84227C13.5543 7.97214 13.6756 8.12254 13.7739 8.28871C14.1593 8.93986 14.0003 9.84523 13.6822 11.656C13.4532 12.9595 13.3387 13.6112 12.942 14.0437C12.839 14.1559 12.7239 14.2554 12.5988 14.3401C12.1167 14.6667 11.4766 14.6667 10.1965 14.6667H5.80354C4.5234 14.6667 3.88334 14.6667 3.40122 14.3401C3.27613 14.2554 3.16097 14.1559 3.05804 14.0437C2.66132 13.6112 2.54682 12.9595 2.31783 11.656Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlpenFolder);
export default __webpack_public_path__ + "static/media/olpenFolder.ecedb54c01c14cdf387fa9ab42909040.svg";
export { ForwardRef as ReactComponent };